// extracted by mini-css-extract-plugin
export default {"content":"Favorites_content__LKAXd"};